import { ReactNode } from "react";

import { IconInfoCircle, IconPencil, IconTrash } from "@tabler/icons";
import { useTheme } from "styled-components";

import { ID } from "@sso/types";
import { RowContainer, RowContainerProps } from "@sso/ui/FlexBox";
import { IconButton } from "@sso/ui/IconButton";

interface TableActionsProps extends RowContainerProps {
  id: ID;
  children?: ReactNode;
  onEditClick?: (id: ID) => void;
  onRemoveClick?: (id: ID) => void;
  showInfo?: boolean;
  onInfoClick?: (id: ID) => void;
}

export const TableActions = ({ id, onEditClick, onRemoveClick, children, showInfo, onInfoClick, ...rowContainerProps }: TableActionsProps) => {
  const theme = useTheme();

  const handleOnEditClick = () => onEditClick && onEditClick(id);
  const handleOnRemoveClick = () => onRemoveClick && onRemoveClick(id);
  const handleOnInfoClick = () => onInfoClick && onInfoClick(id);

  return (
    <RowContainer justify="center" {...rowContainerProps}>
      {children}
      {showInfo && <IconButton color={theme.colors.grey[700]} hoverColor={theme.colors.info.main} onClick={handleOnInfoClick}>
        <IconInfoCircle />
      </IconButton>}
      {!showInfo && <span style={{ width: "35px" }} />}
      <IconButton color={theme.colors.grey[700]} hoverColor={theme.colors.info.main} onClick={handleOnEditClick}>
        <IconPencil />
      </IconButton>
      <IconButton color={theme.colors.grey[700]} hoverColor={theme.colors.error.main} onClick={handleOnRemoveClick}>
        <IconTrash />
      </IconButton>
    </RowContainer>
  );
};
